exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copy-btn[data-v-77b71fb7]{position:relative;top:-37px;right:-186px;margin:0;border-radius:20px;border:1px solid #1e73bd;background-color:#1e73bd}.copy-btn[data-v-77b71fb7]:hover{border:1px solid #23a6cd;background-color:#23a6cd}", ""]);

// exports
